import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { TICKET_MODULE_NAMESPACE, TICKET_GET_TICKETS, TICKET_SET_PARAMETER, TICKET_RESET_TICKETS, TICKET_SET_LOADER_STATE, TICKET_LOADERS } from '../../../store/ticket'
import { ITicketListingViewModel, ITicketParameter } from '../../../models/ticket'
import {ActivityStatus, StateTypes} from '../../../common/enums'
import { SERIVCEBOOK_MODULE_NAMESPACE, SERVICEBOOK_GET_SERVICEBOOK } from '../../../store/service-book'
import { IServiceBookDetails } from '../../../store/service-book/service-book-state.store'

const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)

@Component({
  components: {
    'list-condition': async () => import('../components/ticket-list-conditions/TicketListConditions.vue'),
    'list-item': async () => import('../components/ticket-list-item/TicketListItem.vue'),
    'ticket-list-loader': async () => import('../loaders/ticket-list-loader/TicketListLoader.vue')
  }
})
class TicketListChildContainer extends Vue {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    console.log('CONSTRUCTOR TICKET CHILD LIST')
    super()
  }

  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails
  @ServiceBookStore.Action(SERVICEBOOK_GET_SERVICEBOOK)
  storeGetServiceBook: (id:string) => Promise<any>


  @TicketStore.Getter ticketParameter: ITicketParameter;
  @TicketStore.Getter characterProblemsTranslation: any;
  @TicketStore.Getter ticketViewModels: ITicketListingViewModel[];
  @TicketStore.Getter activityStatus: ActivityStatus;
  @TicketStore.Getter pagination: { total: number, skip: number, limit: number };
  @TicketStore.Getter loaders: Map<string, boolean>;

  @TicketStore.Mutation(TICKET_SET_PARAMETER)
  storeSetTicketParameter: (param: ITicketParameter) => void;
  @TicketStore.Mutation(TICKET_RESET_TICKETS)
  storeResetTickets: () => void;
  @TicketStore.Mutation(TICKET_SET_LOADER_STATE)
  storeSetLoaderState: (payload: { key: string, value: boolean }) => void

  @TicketStore.Action(TICKET_GET_TICKETS)
  storeGetTickets: (payload: { param: ITicketParameter, merge?: boolean }) => Promise<ITicketListingViewModel[]>

  get coSearchParameter (): ITicketParameter {
    return this.ticketParameter
  }
  set coSearchParameter (val: ITicketParameter) {
    this.storeSetTicketParameter(val)
  }


  beforeMount () {
    if(this.$route.path.includes('service-book')){
      if(!this.currentServiceBook.apartment)
      {
        const id = this.$route.params.id
        this.storeGetServiceBook(id).then(()=>{
          this.storeSetTicketParameter({
            ...this.ticketParameter,
            apartment:this.currentServiceBook.apartment.id,
            block:[parseInt(this.currentServiceBook.apartment.fk_apartment_block)]
          })
          this.setParamaterOnMount()
        })
      } else {
        this.storeSetTicketParameter({
          ...this.ticketParameter,
          apartment:this.currentServiceBook.apartment.id,
          block:[parseInt(this.currentServiceBook.apartment.fk_apartment_block)]
        })
        this.setParamaterOnMount()
      }
    } else {
      this.setParamaterOnMount()
    }

  }


  setParamaterOnMount()
  {
    /** Assign default value for state */
    if (!this.ticketParameter.state || this.ticketParameter.state.length === 0) {
      this.storeSetTicketParameter({
        ...this.ticketParameter,
        state: [StateTypes.Open, StateTypes.InProgress, StateTypes.ReOpen]
      })
    }

    /** Assign default value for visibility */
    if (!this.ticketParameter.visibility) {
      if (this.$route.meta.filter_ticket_agency) {
        this.storeSetTicketParameter({
          ...this.ticketParameter,
          visibility: 'agency'
        })
      } /* else if (this.$route.meta.filter_ticket_park) {
      this.storeSetTicketParameter({
        ...this.ticketParameter,
        visibility: "park"
      })
      } */ else {
        this.storeSetTicketParameter({
          ...this.ticketParameter,
          visibility: 'self'
        })
      }
    }
  }

  get coTicketLoader() {
    return this.loaders.get(TICKET_LOADERS.LIST)
  }

  setListLoaderState (value: boolean) {
    this.storeSetLoaderState({ key: TICKET_LOADERS.LIST, value })
  }
}

export default TicketListChildContainer



// WEBPACK FOOTER //
// ./src/containers/ticket/ticket-child-list/index.ts